import { render } from "./CurrentDate.vue?vue&type=template&id=2f5f8978&scoped=true&ts=true"
import script from "./CurrentDate.vue?vue&type=script&lang=ts"
export * from "./CurrentDate.vue?vue&type=script&lang=ts"

import "./CurrentDate.vue?vue&type=style&index=0&id=2f5f8978&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f5f8978"]])

export default __exports__